module.exports = __webpack_public_path__ + "static/image1-d9324c7c710283a6bb264576a41be979.jpg";